import "./CalenderSession.scss";
import { Calendar, momentLocalizer } from "react-big-calendar";
// import moment from "moment";
import moment from 'moment-timezone';
import "react-big-calendar/lib/css/react-big-calendar.css";
import { useEffect, useState } from "react";
import CreateSessionDialog from "../CreateSessionDialog/CreateSessionDialog";
import {
  ADMIN_ROLES,
  API_RESPONSE,
  COMMON_CONSTANTS,
  CREATE_SESSIONS_FIELD,
  I18_TRANSLATION_COMMON,
  MODES,
  NUMBER_CONSTANTS,
  STORAGE_KEYS,
} from "../../../../Utilities/Constants/Constants";
import { axiosInstance } from "../../../../Services/Interceptor/Interceptor";
import API_END_POINTS from "../../../../Utilities/Constants/ApiEndpoints";
import { useTranslation } from "react-i18next";
import "moment/locale/ar";
import { GetSessionStorageData, nullUndefinedEmptyCheck } from "../../../../Services/Helpers/Helper";
import RecreationalCreateSessionDialog from "../RecreationalCreateSessionDialog/RecreationalCreateSessionDialog";
import { toast } from "react-toastify";
import { REGISTRATION_ERRORS } from "../../../../Utilities/Constants/Validations";
import CampCreateSessionDialog from "../CampCreateSession/CampCreateSession";

const CalenderSession = () => {
  const { t, i18n } = useTranslation(I18_TRANSLATION_COMMON.COMMON);
  const [dialogOpenStatus, setDialogOpenStatus] = useState(API_RESPONSE.FALSE);
  const [startDate, setStartDate] = useState("");
  const [currentMode, setCurrentMode] = useState("")
  const [editPayload, setEditPayload]: any = useState();
  const [currentViewType, setCurrentViewType] = useState(CREATE_SESSIONS_FIELD.MONTH)
  /* Constant for demo purpose */
  const [myEventsList, setMyEventsList] = useState([]);
  const localizer = momentLocalizer(moment);
  const [roleId, setRoleId] = useState("")

  useEffect(() => {

  }, []);


  /* Getting service provider's role */
  const getUserRole = () => {
    let role: any = GetSessionStorageData(STORAGE_KEYS.ROLE);
    setRoleId(role);
    getSessionsList(role);
  }

  /* Changing moment locale on langugae change */
  useEffect(() => {
    getUserRole();
    // moment.locale(i18n.language);
    moment.locale('en');
    localizer.formats = { ...localizer.formats, };
  }, [t]);

  /* Event select function call */
  const onSelectEvent = (event: any, e: any) => {
    setCurrentMode(MODES.EDIT)
    setDialogOpenStatus(API_RESPONSE.TRUE);
    setDate(e.start);
    setEditPayload(event);
  };



  /* Changing time format */
  const timeFormat = (time: any) => {
    return moment(time, COMMON_CONSTANTS.HM_FORMAT).format(COMMON_CONSTANTS.HMA_FORMAT);
  }

  /* Event component for rendering with time */
  const eventPropsRender = (event: any) => {
    return (
      <div className={event.event.free_session === API_RESPONSE.TRUE ? " free-session" : "time-wrapper"}>
        <p className="event-title">{event.title}</p>
        {currentViewType === CREATE_SESSIONS_FIELD.MONTH && <p className="event-time">{timeFormat(event.event.start)}-{timeFormat(event.event.end)}</p>}
      </div>
    )
  }
  const currentTime = moment();
const dubaiTime = currentTime.tz('Asia/Dubai');
// const [dubaiCurrentTime, setDubaiCurrentTime] = useState(moment().tz('Asia/Dubai'));

  const TimeIndicator = () => {
    
    const dubaiCurrentTime = moment.tz('Asia/Dubai');
    // const dubaiCurrentTime = moment().tz('Asia/Dubai');
      console.log(dubaiCurrentTime.format(),'-----------')
      const totalMinutesInDay = 24 * 60; // Total number of minutes in a day

      // Calculate the top position percentage based on the current time in Dubai
      const topPosition = ((dubaiCurrentTime.hours() * 60 + dubaiCurrentTime.minutes()) / (24 * 60)) * 100;
       console.log(topPosition,'top position')
    return (
      <div
        style={{
          position: 'absolute',
          top: `${topPosition}%`,
          left: 100,
          right: 20,
          height: 1,
          backgroundColor: 'green',
          zIndex: 9999,
        }}
      />
    );
  };


  /* Rendering calender */
  const renderCalendar = () => {
    // moment.locale(i18n.language);
    moment.locale('en');
    return (
      <Calendar
        selectable
        localizer={localizer}
        events={myEventsList}
        onDoubleClickEvent={onDoubleClick}
        onView={onSelecting}

        onSelectSlot={(e: any) => {
          if (moment(e.start).format(COMMON_CONSTANTS.YMD_FORMAT) >= moment(new Date()).format(COMMON_CONSTANTS.YMD_FORMAT)) {
            setCurrentMode(MODES.CREATE);
            setDialogOpenStatus(API_RESPONSE.TRUE);
            setDate(e.start);
          } else {
            toast.error(REGISTRATION_ERRORS.SESSION_VALID_DATE);
          }

        } }
        onKeyPressEvent={() => { } }
        showMultiDayTimes={true}
        onSelectEvent={(event: any, e: any) => { onSelectEvent(event, e); } }
        components={{
          event: eventPropsRender,
          // timeIndicator: TimeIndicator,
          
          // toolbar: CustomToolbar,
        }} /> 
      )
  };

  /* Formatting response as per calender requirements */
  const formatEvents = (data: any) => {
    const format = data.map((date: any) => {
      return {
        // start: moment(date.start).toDate(),
        // end: moment(date.end).toDate(),
        start: new Date(date.start),
        end: new Date(date.end),
        title: date.title,
        slot_id: date.session_slot,
        timeslot_id: date.id,
        free_session: date.is_free_session,
        service_session_id: date.service_provider_id,
        teach_service: date.teach_service_provider_id,
      };
    });
    setMyEventsList(format);
  };


  /* Sessionslist API call  */
  const onGetSessions = (payload: any) => {
    axiosInstance
      .post(API_END_POINTS.SESSIONS_LIST, payload)
      .then((response) => {
        if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
          formatEvents(response.data.result.data);
        }
      });
  }

  /* Sessions list Payload based on role */
  const getSessionsList = (role: any) => {
    let teachId: number = 0;
    if (role === ADMIN_ROLES.TUTOR) {
      teachId = NUMBER_CONSTANTS.ONE;
      onGetSessions({ teach_service_provider: teachId });
    } else
      if (role === ADMIN_ROLES.RECREATIONAL_CAMP) {
        teachId = NUMBER_CONSTANTS.THREE;
        onGetSessions({ teach_service_provider: teachId });
      } else if (role === ADMIN_ROLES.RECREATIONAL_PERSONAL) {
        teachId = NUMBER_CONSTANTS.TWO;
        onGetSessions({ teach_service_provider: teachId });
      };


  };

  /* Setting start date */
  const setDate = (date: any) => {
    setStartDate(moment(date).local().format(COMMON_CONSTANTS.MDY_FORMAT));
  };

  const onDoubleClick = () => {
  };

  const onSelecting = (event: any) => {
    setCurrentViewType(event)
  };

  /* Close dialog function call */
  const onCloseDialog = () => {
    setDialogOpenStatus(API_RESPONSE.FALSE);
    setCurrentMode("");
    getUserRole();
  };

  return (
    <div className="calender-session-wrapper">
      {nullUndefinedEmptyCheck(currentMode) && roleId === ADMIN_ROLES.TUTOR && <CreateSessionDialog
        modalState={dialogOpenStatus}
        slotDate={startDate}
        dialogStatus={onCloseDialog}
        mode={currentMode}
        payload={editPayload}
      />}
      {nullUndefinedEmptyCheck(currentMode) && roleId === ADMIN_ROLES.RECREATIONAL_PERSONAL && <RecreationalCreateSessionDialog
        modalState={dialogOpenStatus}
        slotDate={startDate}
        dialogStatus={onCloseDialog}
        mode={currentMode}
        payload={editPayload}
      />}
      {nullUndefinedEmptyCheck(currentMode) && roleId === ADMIN_ROLES.RECREATIONAL_CAMP && <CampCreateSessionDialog
        modalState={dialogOpenStatus}
        slotDate={startDate}
        dialogStatus={onCloseDialog}
        mode={currentMode}
        payload={editPayload}
      />}
      <div>
        {renderCalendar()}
      </div>
    </div>
  );
};

export default CalenderSession;
